export default function () {
  return {
    selectedTraining: null,
    highestHr: null,
    onlineUsers: []
  }
}